import * as React from "react";

const SvgComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.222 12.444V3.556a1.778 1.778 0 1 0-1.778-1.778H3.556a1.778 1.778 0 1 0-1.778 1.778v8.888a1.778 1.778 0 1 0 1.778 1.778h8.888a1.777 1.777 0 1 0 1.778-1.778ZM2.667 3.308c.266-.154.487-.375.642-.641h2.024L2.667 5.333V3.308Zm0 2.914 3.555-3.556H8L2.667 8V6.222Zm0 2.667 6.222-6.222h1.778l-8 8V8.888Zm.362 4.082a1.776 1.776 0 0 0-.362-.28v-1.136l8.888-8.888h1.135c.079.133.172.255.28.362L3.03 12.97Zm10.304-.28a1.78 1.78 0 0 0-.643.642h-1.135l1.778-1.778v1.135Zm0-2.025-2.667 2.667H8.89l4.444-4.444v1.777Zm0-2.666L8 13.333H6.222l7.111-7.11V8Zm0-2.667-8 8H3.555l9.778-9.777v1.777Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
